module.exports = __webpack_public_path__ + "img/uparw.ff044a1e.svg";